// @flow
import { compose, applyMiddleware, createStore, combineReducers } from 'redux'
import { reducer as ui } from 'redux/modules/ui'
import { reducer as config } from 'redux/modules/config'
import { reducer as owner } from 'redux/modules/owner'
import { reducer as room } from 'redux/modules/room'
import { reducer as search } from 'redux/modules/search'
import { reducer as favorite } from 'redux/modules/favorite'
import { reducer as user } from 'redux/modules/remote/user'
import { reducer as master } from 'redux/modules/remote/master'
import { reducer as localUser } from 'redux/modules/local/user'
import { reducer as localRooms } from 'redux/modules/local/rooms'
import { reducer as reservation } from 'redux/modules/reservation'
import { reducer as reservationDetail } from 'redux/modules/reservationDetail'
import { reducer as reservationReputation } from 'redux/modules/reservationReputation'
import { reducer as reservationEdit } from 'redux/modules/reservationEdit'
import rootSaga from 'redux/modules/sagas'

import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'

const sagaMiddleware = createSagaMiddleware()

const middlewares = []

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger)
}
middlewares.push(sagaMiddleware)

let composeEnhancers = compose
if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-underscore-dangle, no-undef */
  composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose
  /* eslint-enable no-underscore-dangle, no-undef */
}

export default (initialState: Object = {}) => {
  const store = createStore(
    combineReducers({
      ui,
      config,
      owner,
      room,
      search,
      favorite,
      user,
      master,
      localUser,
      localRooms,
      reservation,
      reservationDetail,
      reservationReputation,
      reservationEdit,
    }),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  )
  sagaMiddleware.run(rootSaga)
  return store
}



// WEBPACK FOOTER //
// ./src/redux/store/index.js